import { MoneyPoolDeedTypeTransactional } from '../moneyPools'

interface IFundsItems {
    title: string
    members: number
    exist: number
    membership: number
    date: string
    status: string
    id: number
}

export const FundsItems: Array<IFundsItems> = [
    {
        id: 0,
        title: 'صندوق حضرت الزهرا (ص)',
        members: 3521,
        exist: 11000000,
        membership: 500000,
        date: '۲۷ اردیبهشت ۱۴۰۱',
        status: 'pending',
    },
]

export const TRANSACTION_STATE_INIT = 'init'
export const TRANSACTION_STATE_TOKENED = 'tknd'
export const TransactionStateInProgress = 'inpg'
export const TransactionStateToBank = 'tbnk'
export const TransactionStateSuccessful = 'scss'
export const TRANSACTION_STATE_UNSUCCESSFUL = 'unsc'

export const InProgressTransactionStatusText = 'In Progress Transaction'
export const DepositedTransactionStatusText = 'Deposited Transaction'
export const DepositedByManagerTransactionStatusText =
    'Deposited By Manager Transaction'
export const RegisteredByManagerTransactionStatusText =
    'Registered By Manager Transaction'

export const TransactionStatusText: { [key: string]: string } = {
    [InProgressTransactionStatusText]: 'درحال واریز', //زرد رنگ بشود و با رنگ تکست سفید
    [DepositedTransactionStatusText]: 'واریز شده',
    [DepositedByManagerTransactionStatusText]: ' مدیر',
    [RegisteredByManagerTransactionStatusText]: 'ثبت شده توسط مدیر',
}
export const TransactionStatusTextDesign: { [key: string]: string } = {
    [InProgressTransactionStatusText]: 'bg-yellow-1 text-white',
    [DepositedTransactionStatusText]: 'bg-green-3 text-white',
    [DepositedByManagerTransactionStatusText]: 'bg-blue-6 text-blue-5',
    [RegisteredByManagerTransactionStatusText]: 'bg-blue-6 text-blue-5',
}

export function isCashin(moneyPoolTransaction: IMoneyPoolTransactionResult) {
    return moneyPoolTransaction.type.substring(0, 2) === 'cn'
}

export function getTransactionStatusText(item: IMoneyPoolTransactionResult) {
    if (
        item.state === TransactionStateInProgress ||
        item.state === TransactionStateToBank
    )
        return InProgressTransactionStatusText
    else if (!isCashin(item) && item.state === TransactionStateSuccessful) {
        if (item.deed_type === MoneyPoolDeedTypeTransactional)
            return DepositedTransactionStatusText
        else return DepositedByManagerTransactionStatusText
    } else if (
        isCashin(item) &&
        item.state === TransactionStateSuccessful &&
        item.deed_type !== MoneyPoolDeedTypeTransactional
    )
        return RegisteredByManagerTransactionStatusText
    else return ''
}
